import React, { Fragment } from 'react'
import HRPolicy from '../hr-policy/HRPolicy'
import PagesHeading from '../pages-heding/PagesHeading'

const HrPolicyPage = (props) => {
  return (
    <Fragment>
        <PagesHeading page_title={props.page_title}></PagesHeading>
        <HRPolicy></HRPolicy>
    </Fragment>
  )
}

export default HrPolicyPage